import { useRef, useState } from "react";
import { supabase } from "./api";
import { Box, Button, Flex, FormControl, FormLabel, Heading, Input, Stack } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { path } from "ramda";

const Auth = () => {
    const [helperText, setHelperText] = useState({ error: null, text: null });
    const emailRef = useRef();
    const passwordRef = useRef();
    const texts = useSelector(path(["ui","ui_texts"]));

    const handleLogin = async (type) => {
        const email = emailRef.current?.value;
        const password = passwordRef.current?.value;
        const { user, error } = type === "LOGIN"
                ? await supabase.auth.signInWithPassword({ email, password })
                : await supabase.auth.signUp({ email, password });
        if (error) {
            setHelperText({ error: true, text: error.message });
        } else if (!user && !error) {
            setHelperText({ error: false,text:texts.check_email});
        }
    };

    const forgotPassword = async (e) => {
        e.preventDefault();
        const email = prompt(texts.enter_email);
        if (email === null || email === "") {
            setHelperText({ error: true, text: texts.cannot_restore });
        } else {
            let { error } = await supabase.auth.api.resetPasswordForEmail(email);
            if (error) {console.error("Error: ", error.message);} 
            else {setHelperText({error: false, text: texts.info_sent});}
        }
    };

    const signInWithGoogle = async () => {
        const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
            redirectTo: window.location.origin
        }
        });

        if (error) {
        console.error(error);
        }
    };


    return (
        <Flex justifyContent="center" alignItems="center" p={4} h="100vh">
            <Box className="col-6 form-widget" minW={300} aria-live="polite">
                <Heading textAlign="center">{texts.log_in}</Heading>
                <FormControl>
                    <FormLabel>{texts.mail}</FormLabel>
                    <Input id="email" className="inputField" type="email" placeholder={texts.your_email} 
                        ref={emailRef} />
                    <FormLabel>{texts.password}</FormLabel>
                    <Input id="password" className="inputField" type="password" ref={passwordRef}/>
                    <Flex gap="2" mt="4" mb="4" justifyContent="center">
                        <Button colorScheme="teal" onClick={() => handleLogin("LOGIN")} color="#fff">{texts.log_in}</Button>
                        <Button colorScheme="teal" onClick={() => handleLogin("REGISTER")} color="#fff">{texts.register}</Button>
                    </Flex>
                    <Flex gap="2" mt="4" mb="4" justifyContent="center">
                        <span className="forgotpass" onClick={forgotPassword}>{texts.forgot}</span>
                    </Flex>
                    <Flex gap="2" mt="4" mb="4" justifyContent="center"><Button colorScheme="red" onClick={signInWithGoogle} >
                        Logi sisse Google'ga
                    </Button></Flex>    
                    {!!helperText.text && (<div>{helperText.text}</div>)}
                </FormControl>
            </Box>
        </Flex>
    );
};




export default Auth;